module.exports = __webpack_public_path__ + "img/authorization-resources.4c8a5e2d.svg";